module.exports = __webpack_public_path__ + "img/reference68.ae198adb.jpg";